<template>
  <div class="c-survey__inner c-survey__bg--blue">
    <div class="c-survey__content c-survey__content--padding-ltr">
      <main v-html="pageFour.content" class="c-survey__html"></main>
    </div>
    <div class="c-survey__content c-survey__content--padding c-survey__content--white-bg c-survey__content--page-four">
      <img v-if="pageFour.imageFile" :src="pageFour.imageFile" class="c-survey__page-four-image" />
      <main v-html="pageFour.question" class="c-survey__html"></main>
      <div class="c-survey__actionbutton-row c-survey__actionbutton-row--center">
        <ActionButton :title="pageFour.answerNoLabel" :buttonAction="'questionNo'" :colour="'red'"></ActionButton>
        <ActionButton :title="pageFour.answerYesLabel" :buttonAction="'questionYes'" :colour="'green'"></ActionButton>
      </div>
    </div>
    <div class="c-survey__content-spacer"></div>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import ActionButton from "../ActionButton.vue";

export default {
  created() {},
  computed: {
    ...mapFields(["content.pages.pageFour", "submissionData"]),
  },
  components: { ActionButton },
  mounted() {},
  methods: {},
};
</script>
